import { DestroyUpdater } from "./DestroyUpdater";
export async function loadDestroyUpdater(engine) {
    await engine.addParticleUpdater("destroy", (container) => new DestroyUpdater(engine, container));
}
